import { render, staticRenderFns } from "./addPlusNewCar.vue?vue&type=template&id=20819d1a"
import script from "./addPlusNewCar.vue?vue&type=script&lang=js"
export * from "./addPlusNewCar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports